/* ============================================================================
   SnapTech theme JS.
   Nothing here is required for the page to work — every feature is progressive
   enhancement on top of server-rendered Liquid.
   ========================================================================== */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  document.body && document.body.classList.remove('no-js');

  var CFG = window.SNAPTECH || {};
  var money = function (cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };

  /* --- WhatsApp helpers -------------------------------------------------- */
  function waLink(text) {
    return 'https://wa.me/' + (CFG.whatsapp || '') + '?text=' + encodeURIComponent(text || CFG.waDefault || 'Hi SnapTech!');
  }
  window.stWaLink = waLink;

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-wa-text]');
    if (!el) return;
    el.href = waLink(el.getAttribute('data-wa-text'));
  }, true);

  /* --- Header shadow on scroll ------------------------------------------ */
  var header = document.querySelector('.header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --- Mobile drawer ----------------------------------------------------- */
  var drawer = document.getElementById('drawer');
  var burger = document.getElementById('burger');
  if (drawer && burger) {
    var page = [document.getElementById('main'), document.querySelector('.footer')];
    var setOpen = function (open) {
      drawer.dataset.open = String(open);
      burger.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('st-locked', open);
      page.forEach(function (n) { if (n) n.inert = open; });
      if (open) { var a = drawer.querySelector('nav a'); if (a) setTimeout(function () { a.focus(); }, 120); }
    };
    burger.addEventListener('click', function () { setOpen(drawer.dataset.open !== 'true'); });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a') || e.target.closest('[data-close]')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.dataset.open === 'true') { setOpen(false); burger.focus(); }
    });
    window.matchMedia('(min-width: 961px)').addEventListener('change', function (e) { if (e.matches) setOpen(false); });
  }

  /* --- Toast ------------------------------------------------------------- */
  var toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m4 12.5 5.5 5.5L20 7"/></svg><span></span>';
    toastEl.querySelector('span').textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }
  window.stToast = toast;

  /* --- Cart -------------------------------------------------------------- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) {
          n.textContent = c.item_count;
          n.hidden = c.item_count === 0;
        });
      })
      .catch(function () { /* cart count is cosmetic — never block the page */ });
  }
  refreshCartCount();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-add');
    if (!id) return;
    btn.setAttribute('aria-disabled', 'true');
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.ok ? r.json() : r.json().then(function (d) { throw new Error(d.description || 'Could not add'); }); })
      .then(function () { toast('Added to cart'); refreshCartCount(); })
      .catch(function (err) { toast(err.message || 'Could not add to cart'); })
      .finally(function () { btn.removeAttribute('aria-disabled'); btn.textContent = label; });
  });

  /* --- Cart page quantity ------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var line = b.getAttribute('data-line');
    var next = Number(b.getAttribute('data-qty'));
    b.setAttribute('aria-disabled', 'true');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: next })
    }).then(function () { window.location.reload(); });
  });

  /* --- Product gallery --------------------------------------------------- */
  var thumbs = document.querySelector('.pdp-thumbs');
  if (thumbs) {
    var mainImg = document.querySelector('.pdp-main img');
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !mainImg) return;
      mainImg.src = b.getAttribute('data-full');
      mainImg.alt = b.getAttribute('data-alt') || mainImg.alt;
      thumbs.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-current', String(x === b)); });
    });
  }

  /* --- Shop filtering ---------------------------------------------------- */
  var shop = document.getElementById('shop');
  if (shop) {
    var cards = [];
    var recollect = function () {
      cards = Array.prototype.slice.call(shop.querySelectorAll('[data-product]'));
    };
    recollect();
    var q = document.getElementById('q');
    var brandSel = document.getElementById('brand');
    var sortSel = document.getElementById('sort');
    var chips = Array.prototype.slice.call(document.querySelectorAll('[data-cat]'));
    var countEl = document.getElementById('count');
    var emptyEl = document.getElementById('empty');
    var grid = shop.querySelector('.grid-products');
    var cat = 'all';

    var norm = function (s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); };

    function apply() {
      var term = norm(q && q.value);
      var brand = brandSel ? brandSel.value : '';
      var shown = 0;

      cards.forEach(function (c) {
        var okCat = cat === 'all' || (c.dataset.cat || '').split('|').indexOf(cat) > -1;
        var okBrand = !brand || c.dataset.brand === brand;
        var okTerm = !term || norm(c.dataset.search).indexOf(term) > -1;
        var on = okCat && okBrand && okTerm;
        c.hidden = !on;
        if (on) shown++;
      });

      if (countEl) countEl.innerHTML = '<b>' + shown + '</b> ' + (shown === 1 ? 'product' : 'products');
      if (emptyEl) emptyEl.hidden = shown !== 0;

      if (grid) {
        var mode = sortSel ? sortSel.value : '';
        var ordered = cards.slice();

        if (mode === 'price-asc' || mode === 'price-desc') {
          var dir = mode === 'price-asc' ? 1 : -1;
          ordered.sort(function (a, b) {
            return (Number(a.dataset.price) - Number(b.dataset.price)) * dir;
          });
        } else {
          // Default: Lenovo first (it is the range SnapTech pushes), then
          // cheapest to most expensive within every brand.
          ordered.sort(function (a, b) {
            var al = a.dataset.brand === 'lenovo' ? 0 : 1;
            var bl = b.dataset.brand === 'lenovo' ? 0 : 1;
            if (al !== bl) return al - bl;
            return Number(a.dataset.price) - Number(b.dataset.price);
          });
        }
        ordered.forEach(function (c) { grid.appendChild(c); });
      }
    }

    var debounce = function (fn, ms) {
      var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); };
    };
    if (q) q.addEventListener('input', debounce(apply, 140));
    if (brandSel) brandSel.addEventListener('change', apply);
    if (sortSel) sortSel.addEventListener('change', apply);
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        cat = ch.getAttribute('data-cat');
        chips.forEach(function (x) { x.setAttribute('aria-pressed', String(x === ch)); });
        apply();

        // Make the change visible: put it in the URL (shareable, survives back)
        // and bring the results into view rather than silently swapping cards
        // that may be below the fold.
        try {
          var u = new URL(location.href);
          if (cat === 'all') { u.searchParams.delete('cat'); } else { u.searchParams.set('cat', cat); }
          history.replaceState(null, '', u);
        } catch (e) { /* URL API missing — filtering still works */ }

        var top = shop.getBoundingClientRect().top + window.scrollY - 90;
        if (window.scrollY > top + 40) {
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    // deep link: /pages/shop?cat=gaming or ?q=macbook
    var params = new URLSearchParams(location.search);
    if (params.get('q') && q) q.value = params.get('q');
    if (params.get('cat')) {
      var want = params.get('cat');
      var match = chips.filter(function (c) { return c.getAttribute('data-cat') === want; })[0];
      if (match) { cat = want; chips.forEach(function (x) { x.setAttribute('aria-pressed', String(x === match)); }); }
    }
    if (params.get('brand') && brandSel) brandSel.value = params.get('brand');
    apply();

    // The collection section swaps in the full catalogue once it loads.
    document.addEventListener('st:products-loaded', function () { recollect(); apply(); });
  }

  /* --- Hero slideshow ---------------------------------------------------- */
  document.querySelectorAll('[data-slider]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.slide'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-go]'));
    var i = 0, timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wait = Number(root.getAttribute('data-interval')) || 6000;
    var auto = root.getAttribute('data-autoplay') === 'true' && !reduced;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-on', k === i);
        if (k === i) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-on', k === i);
        d.setAttribute('aria-selected', String(k === i));
      });
    }
    function start() { if (auto) { stop(); timer = setInterval(function () { show(i + 1); }, wait); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    var next = root.querySelector('[data-next]');
    var prev = root.querySelector('[data-prev]');
    if (next) next.addEventListener('click', function () { show(i + 1); start(); });
    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(Number(d.getAttribute('data-go'))); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { show(i + 1); start(); }
      if (e.key === 'ArrowLeft') { show(i - 1); start(); }
    });

    // swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) show(dx < 0 ? i + 1 : i - 1);
      x0 = null; start();
    });

    // Pause while the tab is hidden so it does not race through slides.
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    show(0);
    start();
  });

  /* --- Scroll reveal ----------------------------------------------------- */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nodes = document.querySelectorAll('[data-reveal]');
  if (reduce || !('IntersectionObserver' in window)) {
    nodes.forEach(function (n) { n.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    nodes.forEach(function (n) { io.observe(n); });
    // Failsafe: never leave content invisible if the observer misfires.
    setTimeout(function () { nodes.forEach(function (n) { n.classList.add('is-in'); }); }, 2600);
  }
})();
